import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { numberToStrCurrency } from 'Shared/CurrencyLabel/CurrencyLabel'

export const BarCodeSection = ({
  barCode,
  accountType,
  data,
  billValue,
  pointsValue,
  pointsName,
  decimalPlaces,
  serviceId
}) => (
  <div className='col-12 txt-left justify-content-center align-self-center row mx-0'>
    <p className='d-none col-12 mx-0 px-0 txt-body-sm txt-subtitle txt-font-body color-ui-2'>
      Código de barras: <strong>{barCode}</strong>
    </p>
    <p className='col-12 mx-0 px-0 txt-body-sm txt-font-body color-ui-2'>
      Tipo da conta:{' '}
      <strong>
        {serviceId
          ? accountType.find(item => item.serviceId === serviceId).name
          : ''}
      </strong>
    </p>
    <p className='col-12 mx-0 px-0 txt-body-sm txt-font-body color-ui-2'>
      Data de vencimento: <strong>{data}</strong>
    </p>
    <p className='col-12 mx-0 px-0 txt-body-sm  txt-font-body color-ui-2'>
      Valor da conta:{' '}
      <strong>
        {billValue ? `R$ ${numberToStrCurrency(billValue, 2)}` : ''}
      </strong>
    </p>
    <p className='col-12 mx-0 px-0 txt-body-sm txt-font-body color-ui-2'>
      Valor total:{' '}
      <strong>
        {pointsValue
          ? `${numberToStrCurrency(pointsValue, decimalPlaces)} ${pointsName}`
          : ''}
      </strong>
    </p>
  </div>
)

BarCodeSection.propTypes = {
  barCode: PropTypes.string,
  accountType: PropTypes.array,
  serviceId: PropTypes.number,
  data: PropTypes.string,
  billValue: PropTypes.number,
  pointsValue: PropTypes.number,
  pointsName: PropTypes.string,
  decimalPlaces: PropTypes.number
}

const mapStateToProps = ({ catalog: { currencyConfiguration } }) => ({
  pointsName: currencyConfiguration.pointsName,
  decimalPlaces: currencyConfiguration.decimalPlaces
})

export default connect(
  mapStateToProps,
  null
)(BarCodeSection)



// WEBPACK FOOTER //
// ./src/features/BillPayment/Sidebar/BarCodeSection.js